import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/@mantine/dates/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/@mantine/nprogress/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/@mantine/notifications/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/swiper/modules/free-mode.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/node_modules/swiper/modules/scrollbar.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2538047745/src/apex.web/src/components/Providers/RootProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/src/styles/variables.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/src/styles/tailwind.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2538047745/src/apex.web/src/styles/globals.css");
